import {useCallback, useEffect} from 'react';

type KeyHandler = (e: KeyboardEvent) => void;
type Options = {
    keys?: string[]; // 비교할 키 목록, 소문자
    enableInInputs?: boolean; // true면 input/textarea 등 입력중에도 동작
    useCode?: boolean; // true면 event.code 사용 (물리적 키 위치 기준)
    capture?: boolean; // addEventListener 옵션
};

const useKeyboards = (handler: (key: string, e: KeyboardEvent) => void, opts?: Options) => {
    const {keys = ['j', 'k', 'l'], enableInInputs = false, useCode = false, capture = false} = opts || {};

    const onKeyDown = useCallback(
        (e: KeyboardEvent) => {
            // SSR 안전성
            if (typeof window === 'undefined') return;

            // 입력창에서 타이핑 중이면 무시(옵션에 따라)
            if (!enableInInputs) {
                const target = e.target as HTMLElement | null;
                if (target) {
                    const tag = target.tagName;
                    const isEditable = target.isContentEditable;
                    if (tag === 'INPUT' || tag === 'TEXTAREA' || isEditable) {
                        return;
                    }
                    // contenteditable이 할당된 요소들도 무시
                }
            }

            const raw = useCode ? (e as any).code : e.key;
            if (!raw) return;

            const key = String(raw).toLowerCase();

            // keys 배열은 소문자로 전제
            if (keys.includes(key)) {
                handler(key, e);
            }
        },
        [handler, keys.join(','), enableInInputs, useCode]
    ); // keys를 배열로 의존시키면 참조 변경 주의

    useEffect(() => {
        if (typeof window === 'undefined') return;
        document.addEventListener('keydown', onKeyDown, capture);
        return () => document.removeEventListener('keydown', onKeyDown, capture);
    }, [onKeyDown, capture]);
};

export default useKeyboards;
